import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  removeEmail,
  removeRole,
  removeToken,
  removeStageNumber,
} from "./utils/auth-token-utils/cookie";

const LogoutListener: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const syncLogout = (event: StorageEvent) => {
      if (event.key === "isLoggedOut") {
        console.log("Logged out from another tab");
        // Perform the necessary logout actions for this tab
        removeToken();
        // removeRole();
        removeEmail();
        removeStageNumber();
        navigate("/signin"); // Redirect to the login or signup page
      }
    };

    // Add storage event listener
    window.addEventListener("storage", syncLogout);

    return () => {
      // Cleanup when component unmounts
      window.removeEventListener("storage", syncLogout);
    };
  }, [navigate]);

  return null; // No need to render anything
};

export default LogoutListener;
